/**
 * The list of bank account and swift codes
 *
 *
 */
/* eslint-disable */

module.exports = [
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank"
    },
    {
        "code": "SICOTHBK",
        "bank": "SIAM COMERCIAL BANK"
    },
    {
        "code": "NISPIDJA",
        "bank": "OCBC NISP"
    },
    {
        "code": "MBBEMYKL",
        "bank": "Maybank"
    },
    {
        "code": "CENAIDJA",
        "bank": "Bank Central Asia"
    },
    {
        "code": "HASEHKHH",
        "bank": "Hang Seng Bank"
    },
    {
        "code": "BKCHHKHH",
        "bank": "Bank of China (Hong Kong) Limited"
    },
    {
        "code": "HSBCHKHHHKH",
        "bank": "HSBC The Hong Kong and Shanghai Banking Corporation"
    },
    {
        "code": "CENAIDJA",
        "bank": "Bank Central Asia (BCA)"
    },
    {
        "code": "MBBEMYKLXXX",
        "bank": "Maybank"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB"
    },
    {
        "code": "PBBEMYKL",
        "bank": "Public Bank"
    },
    {
        "code": "RHBBMYKLXXX",
        "bank": "RHB Bank"
    },
    {
        "code": "CTBBMYKL",
        "bank": "CIMB Islamic BANK BERHAD"
    },
    {
        "code": "OCBCMYKLXXX",
        "bank": "OCBC BANK"
    },
    {
        "code": "MBBEMYKL",
        "bank": "Maybank Berhad"
    },
    {
        "code": "HLBBMYKLXXX",
        "bank": "Hong Leong Bank"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Berhad"
    },
    {
        "code": "VTCBVNVX",
        "bank": "Techcombank"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn bank"
    },
    {
        "code": "KRTHTHBK",
        "bank": "Krungthai Bank"
    },
    {
        "code": "PBBEMYKLXXX",
        "bank": "PUBLIC BANK BERHAD"
    },
    {
        "code": "BRINIDJA",
        "bank": "Bank Rakyat Indonesia (BRI)"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB"
    },
    {
        "code": "BKKBTHBK",
        "bank": "Bangkok Bank"
    },
    {
        "code": "BFTVVNVX",
        "bank": "Vietcombank"
    },
    {
        "code": "WPACAU2S",
        "bank": "Westpac Business"
    },
    {
        "code": "RHBBMYKLXXX",
        "bank": "RHB BANK BERHAD"
    },
    {
        "code": "ARBKMYKLXXX",
        "bank": "AMBANK (M) BERHAD"
    },
    {
        "code": "UBPHPHMMXXX",
        "bank": "Union Bank of the Philippines"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "BANK OF THE PHILIPPINE ISLANDS"
    },
    {
        "code": "MBBEMYKLPEN",
        "bank": "Maybank"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Bank Malaysia"
    },
    {
        "code": "OCBCMYKL",
        "bank": "OCBC BANK"
    },
    {
        "code": "PBBEMYKL",
        "bank": "PUBLIC BANK BERHAD"
    },
    {
        "code": "MBBEMYKLSAC",
        "bank": "Maybank"
    },
    {
        "code": "KASITHBKXXX",
        "bank": "Kasikorn bank"
    },
    {
        "code": "KRTHTHBKXXX",
        "bank": "Krung Thai Bank\r\n\r\n"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB Bank Malaysia"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "Bank of the Philippine Islands - Savings"
    },
    {
        "code": "BNORPHMMXXX",
        "bank": "BDO UNIBANK, INC."
    },
    {
        "code": "PNBMPHMMXXX",
        "bank": "PHILIPPINE NATIONAL BANK"
    },
    {
        "code": "CENAIDJA",
        "bank": "BANK Central Asia Cab Graha Paramita"
    },
    {
        "code": "CENAIDJA",
        "bank": "BANK CENTRAL ASIA\r\n"
    },
    {
        "code": "BMRIIDJA",
        "bank": "BANK MANDIRI (PERSERO), PT\r\n"
    },
    {
        "code": "RHBBMYKL",
        "bank": "RHB Bank"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank Public Company Limited"
    },
    {
        "code": "KASITHBKXXX",
        "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
    },
    {
        "code": "CITIVNVX",
        "bank": "CITIBANK N.A.\r\n"
    },
    {
        "code": "BKKBTHBK",
        "bank": "BANGKOK BANK PUBLIC COMPANY LIMITED\r\n"
    },
    {
        "code": "TMBKTHBKXXX",
        "bank": "THANACHART BANK PUBLIC COMPANY LIMITED\r\n"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)\r\n"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD"
    },
    {
        "code": "HBMBMYKL",
        "bank": "HSBC"
    },
    {
        "code": "SICOTHBK",
        "bank": "SIAM COMMERCIAL BANK PCL., THE\r\n"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB Bank Berhad"
    },
    {
        "code": "BOPIPHMM",
        "bank": "BANK OF THE PHILIPPINE ISLANDS"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Bank Berhad"
    },
    {
        "code": "ORSIPHM1",
        "bank": "BANCO DE ORO"
    },
    {
        "code": "KASITHBK",
        "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
    },
    {
        "code": "SICOTHBKXXX",
        "bank": "siam commercial bank"
    },
    {
        "code": "TMBKTHBK",
        "bank": "TMBThanachart Bank Public Company Limited"
    },
    {
        "code": "SCBLMYKXXXX",
        "bank": "STANDARD CHARTERED BANK"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank Public Company Limited"
    },
    {
        "code": "PHBMMYKL",
        "bank": "AFFIN BANK BERHAD"
    },
    {
        "code": "ICBVVNVX946\r\n",
        "bank": "VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE (FORMERLY VIETNAM BANK FOR INDUSTRY AND TRADE)"
    },
    {
        "code": "BNORPHMMXXX",
        "bank": "BANCO DE ORO UNIBANK"
    },
    {
        "code": "MBBEMYKLXXX",
        "bank": "Maybank"
    },
    {
        "code": "MSCBVNVX004",
        "bank": "MILITARY COMMERCIAL JOINT STOCK BANK"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank\r\n"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "UNION BANK OF THE PHILIPPINES"
    },
    {
        "code": "BNORPHMM",
        "bank": "BDO UNIBANK, INC."
    },
    {
        "code": "MBBEMYKLIPH",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
    },
    {
        "code": "SACLVNVX",
        "bank": "SAIGON COMMERCIAL BANK"
    },
    {
        "code": "CENAIDJAXXX",
        "bank": "Bank Central Asia"
    }
]


//////////////////
// WEBPACK FOOTER
// ./static/sources/bank_accounts.js
// module id = 750
// module chunks = 0